import type { User } from "./types";

/**
 * Best-effort display name for a user (issue #101).
 *
 * `name` is required for new registrations but null for pre-existing
 * accounts, so any surface that shows "who" a user is falls back to
 * the email when no name is stored — never a blank or a crash.
 */
export function displayName(user: Pick<User, "name" | "email">): string {
  return user.name?.trim() || user.email;
}

/**
 * Case-insensitive search match against a user's display name or email.
 *
 * Shared by the teacher roster and the enrollment picker so the two
 * searches behave identically: surrounding whitespace is ignored, and an
 * empty or whitespace-only query matches everyone.
 */
export function matchesUserSearch(
  user: Pick<User, "name" | "email">,
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (q === "") return true;
  return (
    displayName(user).toLowerCase().includes(q) ||
    user.email.toLowerCase().includes(q)
  );
}
